// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ProjectDocumentID = function (x) {
    return x;
};
var tsBridgeProjectDocumentID = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ProjectDocumentID")("__brandProjectDocumentID"));
    }
};
var writeProjectDocumentID = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showProjectDocumentID = Data_Show.showString;
var readProjectDocumentID = Simple_JSON.readString;
var ordProjectDocumentID = Data_Ord.ordString;
var newtypeProjectDocumentID = {
    Coercible0: function () {
        return undefined;
    }
};
var makeProjectDocumentID = ProjectDocumentID;
var eqProjectDocumentID = Data_Eq.eqString;
export {
    ProjectDocumentID,
    makeProjectDocumentID,
    unwrap,
    newtypeProjectDocumentID,
    eqProjectDocumentID,
    ordProjectDocumentID,
    showProjectDocumentID,
    readProjectDocumentID,
    writeProjectDocumentID,
    tsBridgeProjectDocumentID
};
//# sourceMappingURL=index.js.map
